
var filtered_dates;
var eventDates = {};
$(function(){
    //$(this).scrollTop(0);
    setInterval(refresh_my_fixtures, 15000);
    checkNotificationCheckboxes();

    Cookies.remove('fixtures_date');
    if($("#filter_count_ph").length){
        var fc = $("#filter_count_ph").val();
        if(fc > 0){
            $(".filter_count").html(fc);
            $(".filter_count").show();
        }
    }
    $('.modal-dialog').parent().on('show.bs.modal', function(e){
        $(e.relatedTarget.attributes['data-bs-target'].value).appendTo('body');
    });

    if($("#live_today").length){
        $.get(
            ajaxUrl+"/ajax/renderLiveToday.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $(".live_fixtures").html(result.fixtures);
                    $("#live_today_loader").fadeOut(function(){
                        $(".fixtures_today").fadeIn();
                        $(".explanation-list-row")
                            .css("display", "flex")
                            .hide()
                            .fadeIn();
                    });
                    checkNotificationCheckboxes();
                    //$(window).scrollTop(0);
                }
            }
        );
    }

    if($("#reset_results").length){
        Cookies.remove('results_date', { path: '/' });
    }
    if($("#reset_fixtures").length){
        Cookies.remove('fixtures_sel_date', { path: '/' });
    }

    $("#datepicker").hide();
    $("#odds_datepicker").hide();
    $("#datepicker_results").hide();
    $.extend($.datepicker,{_checkOffset:function(inst,offset,isFixed){return offset}});

    var elems = Array.prototype.slice.call(document.querySelectorAll('.js-switch'));
    elems.forEach(function(html) {
        var switchery = new Switchery(html,{ size: 'large' });
    });



    $(".filter_switch").change(function(){
        var filtered_leagues = "";
        var filter_count = 0;
        $(".filter_switch").each(function(){
            if($(this).is(":checked")){
                filtered_leagues += $(this).data("league-id") + ",";
                filter_count++;
            }
        });

        if(filter_count > 0){
            $(".filter_count").html(filter_count);
            $(".filter_count").show();
        } else {
            $(".filter_count").html(0);
            $(".filter_count").hide();
        }

        Cookies.set('filtered_leagues', filtered_leagues, { expires: 7, path: '/' });

        if($(this).data("filter-type") == "fixtures"){
            var callUrl = ajaxUrl + "/ajax/getFixturesByLeagues.php";
            var selected_date = $("#datepicker").datepicker( "getDate" );
        } else {
            var callUrl = ajaxUrl + "/ajax/getResultsByLeagues.php";
            var selected_date = $("#datepicker_results").datepicker( "getDate" );
        }

        var formated_date = moment(selected_date).format("YYYY-MM-DD");

        $.post(
            callUrl,
            {
                date : formated_date,
                leagues : filtered_leagues
            },
            function(data){
                var result = $.parseJSON(data);

                if(result.success == true){
                    $("#fixtures").html(result.data);
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    //loadOdds();
                    if(result.dates != ""){
                        var cookie_dates = JSON.stringify(result.dates);
                        localStorage.setItem('filtered_dates', cookie_dates);
                        var eventDates = {};

                        for (var key in result.dates) {
                            eventDates[new Date(result.dates[key].replace(/-/g, "/") +' 00:00').toString()] = "1";
                        }

                        if($("#datepicker").length){
                            $("#datepicker").datepicker( "option", "beforeShowDay", function(date){
                                var highlight = eventDates[date];
                                if( highlight ) {
                                    return [true, "event", highlight];
                                } else {
                                    return [true, '', ''];
                                }
                            });
                        } else {
                            $("#datepicker_results").datepicker( "option", "beforeShowDay", function(date){
                                var highlight = eventDates[date];
                                if( highlight ) {
                                    return [true, "event", highlight];
                                } else {
                                    return [true, '', ''];
                                }
                            });
                        }

                    } else {
                        Cookies.remove('filtered_dates', { path: '/' });
                    }
                }
            }
        );
    });

    var i = 2;
    var i_r = 4;
    var days = ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'];
    var months = ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'];

    Date.prototype.getMonthName = function() {
        return months[ this.getMonth() ];
    };
    Date.prototype.getDayName = function() {
        return days[ this.getDay() ];
    };

    $(".fixtures_datepicker").click(function(){
        $(this).next().show();
    });

    $("#datepicker_toggle").click(function(){
        $("#datepicker").toggle();
        if($("#datepicker").is(":visible")){
            $(".fa-calendar-alt").hide();
            $(".fa-times").removeClass("hidden");
        } else {
            $(".fa-calendar-alt").show();
            $(".fa-times").addClass("hidden");
        }
    });

    $("#odds_datepicker_toggle").click(function(){
        $("#odds_datepicker").toggle();
        if($("#odds_datepicker").is(":visible")){
            $(".fa-calendar-alt").hide();
            $(".fa-times").removeClass("hidden");
        } else {
            $(".fa-calendar-alt").show();
            $(".fa-times").addClass("hidden");
        }
    });

    $("#datepicker_results_toggle").click(function(){
        $("#datepicker_results").toggle();
        if($("#datepicker_results").is(":visible")){
            $(".fa-calendar-alt").hide();
            $(".fa-times").removeClass("hidden");
        } else {
            $(".fa-calendar-alt").show();
            $(".fa-times").addClass("hidden");
        }
    });
    $("#datepicker").datepicker({
        format: "dd/mm/yy",
        firstDay: 1,
        minDate: 1,
        onSelect: renderMatchesList
    });

    $("#odds_datepicker").datepicker({
        format: "dd/mm/yy",
        firstDay: 1,
        minDate: 0,
        onSelect: renderOddsMatchesList
    });

    if($("#skip_today").length){
        $("#datepicker_results").datepicker({
            firstDay: 1,
            maxDate: -1,
            onSelect: renderResultsList
        });
    } else {
        $("#datepicker_results").datepicker({
            firstDay: 1,
            maxDate: 0,
            onSelect: renderResultsList
        });
    }

    var sel_res_date = Cookies.get('results_date');
    if(sel_res_date != undefined && $("#is_results_page").length){
        $("#datepicker_results").datepicker("setDate", sel_res_date);
        $("#fixtures").css("opacity", "0.2");

        var todayTimeStamp = +new Date; // Unix timestamp in milliseconds
        var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
        var diff = todayTimeStamp - oneDayTimeStamp;
        var yesterdayDate = new Date(diff);
        var yesterdayString = yesterdayDate.getFullYear() + '-' + (yesterdayDate.getMonth() + 1) + '-' + yesterdayDate.getDate();

        $.post(
            ajaxUrl+"/ajax/getResultsByDate.php",
            {
                date : sel_res_date
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#fixtures").html(result.list);
                    $("#fixtures").css("opacity", "1");
                    $("#fixtures_date").html(result.date);
                    if(result.next_disabled == 1){
                        $("#results_next").addClass("nav_disabled");
                    } else {
                        if(yesterdayString == sel_res_date && $("#skip_today").length){
                            $("#results_next").addClass("nav_disabled");
                        } else {
                            $("#results_next").removeClass("nav_disabled");
                        }

                    }
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                }
            }
        );
    }

    var sel_fix_date = Cookies.get('fixtures_sel_date');
    if(sel_fix_date != undefined && $("#is_fixtures_page").length){
        $("#datepicker").datepicker("setDate", sel_fix_date);
        $("#fixtures").css("opacity", "0.2");
        $.post(
            ajaxUrl+"/ajax/getFixturesByDate.php",
            {
                date : sel_fix_date
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#fixtures").html(result.list);
                    $("#fixtures").css("opacity", "1");
                    $("#fixtures_date").html(result.date);
                    if(result.prev_disabled == 1){
                        $("#fixtures_prev").addClass("nav_disabled");
                    } else {
                        $("#fixtures_prev").removeClass("nav_disabled");
                    }
                    checkNotificationCheckboxes();
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                }
            }
        );
    }

    /*$(document).on("click", ".fixture_live", function(){
        var href = $(this).data("href");
        window.location.href = href;
    });*/

    filtered_dates = localStorage.getItem('filtered_dates');
    if(filtered_dates != undefined && filtered_dates != null){
        filtered_dates = $.parseJSON(filtered_dates);
        for (var key in filtered_dates) {
            eventDates[new Date(filtered_dates[key].replace(/-/g, "/") +' 00:00').toString()] = "1";
        }
        $('#datepicker').datepicker( "option", "beforeShowDay", hightlightDates);
        $('#datepicker_results').datepicker( "option", "beforeShowDay", hightlightDates);
    }

    // Fixtures navigation
    $(document).on("click", ".fixtures_nav", function(){
        if($(this).hasClass('navigate_to_today')){
            window.location = "/";
            return;
        }
        if($(this).hasClass("nav_disabled")){
            return false;
        }
        var $picker = $("#datepicker");
        var date=new Date($picker.datepicker('getDate'));

        if($(this).data("direction") == "next"){
            date.setDate(date.getDate()+1);
        } else {
            date.setDate(date.getDate()-1);
        }

        $picker.datepicker('setDate', date);

        renderMatchesList();

        return false;
    });

    $(document).on("click", ".fixtures_odds_nav", function(){
        if($(this).hasClass("nav_disabled")){
            return false;
        }
        var $picker = $("#odds_datepicker");
        var date=new Date($picker.datepicker('getDate'));

        if($(this).data("direction") == "next"){
            date.setDate(date.getDate()+1);
        } else {
            date.setDate(date.getDate()-1);
        }

        $picker.datepicker('setDate', date);
        console.log($('.odds-page-tabs > ul > li > a'));
        $('.odds-page-tabs > ul > li > a[data-odds-type="3way"]').click();

        renderOddsMatchesList();

        return false;
    });

    // Match tip navigation
    $(document).on("click", ".fixtures_bet_nav", function(){
        if($(this).hasClass("nav_disabled")){
            return false;
        }

        renderMatchesListBetting($(this).data("date"));

        return false;
    });

    $(document).on("change", ".notification_switch", function(e){
        e.preventDefault();
        if($(this).hasClass("my_notifications_remove")){
            return false;
        }
        var match_id = $(this).data("match-id");
        if($(this).is(":checked")){
            var checked = 1;
            if($("#is_match_page").length > 0){
                $(".inmatch-notifications-label > .fa-star").addClass("star-activated");
            } else {
                $(this).prev().addClass("star-activated");
                $("a.xl_fav_team[data-match-id='"+match_id+"']"). next().addClass("star-activated");
            }
        } else {
            var checked = 0;
            if($("#is_match_page").length > 0){
                $(".inmatch-notifications-label > .fa-star").removeClass("star-activated");
            } else {
                $(this).prev().removeClass("star-activated");
                $("a.xl_fav_team[data-match-id='"+match_id+"']"). next().removeClass("star-activated");
            }
        }
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl+"/ajax/addToMyFixtures.php",
            {
                match_id : match_id,
                checked : checked,
                user_id : user_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(checked){
                        localStorage.setItem(match_id, user_id);
                    } else {
                        localStorage.removeItem(match_id);
                    }
                    if(result.count > 0){
                        Cookies.set("my_fixtures_count", result.count, { expires: 365, path: '/' });
                        $(".my-matches-count").html(result.count);
                        $(".my-matches-count").fadeIn();
                    } else {
                        Cookies.remove("my_fixtures_count");
                        $(".my-matches-count").html("");
                        $(".my-matches-count").removeClass("my-matches-count-show");
                        $(".my-matches-count").fadeOut();
                    }
                }
            }
        );

        return false;
    });

    $(document).on("click", ".xl_fav_team", function(e){
        e.preventDefault();

        var match_id = $(this).data("match-id");
        if(!$(this).children(":first-child").hasClass("star-activated")){
            var checked = 1;
            $(this).children(":first-child").addClass("star-activated");
        } else {
            var checked = 0;
            $(this).children(":first-child").removeClass("star-activated");
        }
        $("input.notification_switch[data-match-id='"+match_id+"']").trigger("click");

        return false;
    });

    $(document).on("change", ".my_notifications_remove", function(e){
        e.preventDefault();
        var match_id = $(this).data("match-id");
        if($(this).is(":checked")){
            var checked = 1;
            if($("#is_match_page").length > 0){
                $(".inmatch-notifications-label > .fa-star").addClass("star-activated");
            } else {
                $(this).prev().addClass("star-activated");
            }
        } else {
            var checked = 0;
            if($("#is_match_page").length > 0){
                $(".inmatch-notifications-label > .fa-star").removeClass("star-activated");
            } else {
                $(this).prev().removeClass("star-activated");
            }
        }
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl+"/ajax/addToMyFixtures.php",
            {
                match_id : match_id,
                checked : checked,
                user_id : user_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(checked){
                        localStorage.setItem(match_id, user_id);
                    } else {
                        localStorage.removeItem(match_id);
                    }
                    if(result.count > 0){
                        Cookies.set("my_fixtures_count", result.count, { expires: 365, path: '/' });
                        $(".my-matches-count").html(result.count);
                        $(".my-matches-count").fadeIn();
                    } else {
                        Cookies.remove("my_fixtures_count");
                        $(".my-matches-count").html("");
                        $(".my-matches-count").removeClass("my-matches-count-show");
                        $(".my-matches-count").fadeOut();
                    }
                }
                refresh_my_fixtures();
            }
        );

        return false;
    });

    // TV Tableau navigation
    $(document).on("click", ".tv_tableau_nav", function(){
        if($(this).hasClass("nav_disabled")){
            return false;
        }

        renderTvTableau($(this).data("date"));

        return false;
    });

    // Clear my fixtures
    $(document).on("click", "#clear_my_fixtures", function(){
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");
        $.post(
            ajaxUrl+"/ajax/clearMyFixtures.php",
            {
                user_id : user_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    refresh_my_fixtures();
                }
            }
        );

        return false;
    });

    // Results navigation
    $(document).on("click", ".results_nav", function(){
        if($(this).hasClass("nav_disabled")){
            return false;
        }
        var $picker = $("#datepicker_results");
        var date=new Date($picker.datepicker('getDate'));

        if($(this).data("direction") == "next"){
            date.setDate(date.getDate()+1);
        } else {
            date.setDate(date.getDate()-1);
        }

        $picker.datepicker('setDate', date);

        renderResultsList();

        return false;
    });

    $('.bt-ft').children().on('click', function (e) {
        return false;
    });

    $(document).on("click", ".fp_league_standing", function(){
        $(".fp_league_standing").removeClass("fp_league_active");
        $(this).addClass("fp_league_active");
        $("#frontpage-standing").css("opacity", "0.2")
        var league_id = $(this).data("league-id");
        $.post(
            ajaxUrl+"/ajax/getFrontpageStanding.php",
            {
                league_id : league_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#frontpage-standing").html(result.data);
                    $("#frontpage-standing").css("opacity", "1");
                }
            }
        );
        return false;
    });

    $(document).on("click", ".toggle-notification", function(){
        var activated = $(this).data("activated");
        if(activated == 1){
            var checked = 0;
            $(this).html('<i class="fal fa-bell"></i>');
            $(this).data("activated", 0);
        } else {
            var checked = 1;
            $(this).html('<i class="fas fa-check notification-activated" data-fa-transform="shrink-10 up-.5" data-fa-mask="fas fa-bell"></i>');
            $(this).data("activated", 1);
        }
        var match_id = $(this).data("match-id");
        //var user_id = localStorage.getItem("fotboll_com_identifier");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl+"/ajax/addToMyFixtures.php",
            {
                match_id : match_id,
                checked : checked,
                user_id : user_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(checked){
                        localStorage.setItem(match_id, user_id);
                    } else {
                        localStorage.removeItem(match_id);
                    }
                    if(result.count > 0){
                        Cookies.set("my_fixtures_count", result.count, { expires: 365, path: '/' });
                        $(".my-matches-count").html(result.count);
                        $(".my-matches-count").fadeIn();
                    } else {
                        Cookies.remove("my_fixtures_count");
                        $(".my-matches-count").html("");
                        $(".my-matches-count").removeClass("my-matches-count-show");
                        $(".my-matches-count").fadeOut();
                    }
                }
            }
        );
        return false;
    });

    $(document).on("click", ".toggle-favourite-team", function(){
        var activated = $(this).data("activated");
        if(activated == 1){
            var checked = 0;
            $(this).html('<i class="fal fa-shield"></i>');
            $(this).data("activated", 0);
        } else {
            var checked = 1;
            $(this).html('<i class="fas fa-check notification-activated" data-fa-transform="shrink-10 up-.5" data-fa-mask="fas fa-shield"></i>');
            $(this).data("activated", 1);
        }
        /*var match_id = $(this).data("match-id");
        var user_id = Cookies.get("fotboll_com_identifier");

        $.post(
            ajaxUrl+"/ajax/addToMyFixtures.php",
            {
                match_id : match_id,
                checked : checked,
                user_id : user_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(checked){
                        localStorage.setItem(match_id, user_id);
                    } else {
                        localStorage.removeItem(match_id);
                    }
                    if(result.count > 0){
                        Cookies.set("my_fixtures_count", result.count, { expires: 365, path: '/' });
                        $(".my-matches-count").html(result.count);
                        $(".my-matches-count").fadeIn();
                    } else {
                        Cookies.remove("my_fixtures_count");
                        $(".my-matches-count").html("");
                        $(".my-matches-count").removeClass("my-matches-count-show");
                        $(".my-matches-count").fadeOut();
                    }
                }
            }
        );*/
        return false;
    });

    if($("input.fixture_odds").length > 0){
        loadOdds();
    }

    if($("#my-fixtures-page").length > 0){
        refresh_my_fixtures();
    }

});

function hightlightDates(date){
    var highlight = eventDates[date];
    if( highlight ) {
        return [true, "event", highlight];
    } else {
        return [true, '', ''];
    }
}

function loadOdds(){
    var aOdds = {};
    var matches = [];
    aOdds.matches = matches;
    $("input.fixture_odds").each(function(){
        var match_id = $(this).data("match-id");
        var odds = {
            "match_id": match_id,
        }
        aOdds.matches.push(odds);
    });
    $.get(
        ajaxUrl+"/ajax/loadFixtureOdds.php",
        {
            odds : JSON.stringify(aOdds)
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $.each(result.rows, function(i, match){
                    $('.fixture_odds[data-odds-id="' + match.match_id + '"][data-size="lg"]').html(match.lg);
                    $('.fixture_odds[data-odds-id="' + match.match_id + '"][data-size="xs"]').html(match.xs);
                });
            }
        }
    );
}

function renderMatchesList(){
    var $picker = $("#datepicker");
    var date = new Date($picker.datepicker('getDate'));
    date = moment(date).format("YYYY-MM-DD");
    console.log(date);

    Cookies.set('fixtures_sel_date', date, { expires: 0.01, path: '/' });

    $("#fixtures").css("opacity", "0.2");
    $(".fa-calendar-alt").show();
    $(".fa-times").addClass("hidden");

    $.post(
        ajaxUrl+"/ajax/getFixturesByDate.php",
        {
            date : date
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $("#fixtures").html(result.list);
                $("#fixtures").css("opacity", "1");
                $("#fixtures_date").html(result.date);
                if(result.prev_disabled == 1){
                    $("#fixtures_prev").addClass("navigate_to_today");
                } else {
                    $("#fixtures_prev").removeClass("navigate_to_today");
                }
                checkNotificationCheckboxes();
                $('img[data-src]').each(function(img){
                    $(this).attr('src', $(this).data('src'));
                    $(this).removeAttr('data-src');
                });
            }
        }
    );

    $("#datepicker").hide();
}

function renderOddsMatchesList(){
    var $picker = $("#odds_datepicker");
    var date = new Date($picker.datepicker('getDate'));
    date = moment(date).format("YYYY-MM-DD");

    $("#fixtures").css("opacity", "0.2");
    $(".fa-calendar-alt").show();
    $(".fa-times").addClass("hidden");

    $.post(
        ajaxUrl+"/ajax/getOddsFixturesByDate.php",
        {
            date : date
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $("#fixtures").html(result.list);
                $("#fixtures").css("opacity", "1");
                $("#fixtures_date").html(result.date);
                if(result.prev_disabled == 1){
                    $("#fixtures_prev").addClass("nav_disabled");
                } else {
                    $("#fixtures_prev").removeClass("nav_disabled");
                }
                updateOddsList();
            }
        }
    );

    $("#odds_datepicker").hide();
}

function renderMatchesListBetting(date){

    $("#fixtures").css("opacity", "0.2");

    $.post(
        ajaxUrl+"/ajax/getFixturesByDate.php",
        {
            date : date,
            bet : 1
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $("#fixtures").html(result.data);
                $("#fixtures").css("opacity", "1");
            }
            $('img[data-src]').each(function(img){
                $(this).attr('src', $(this).data('src'));
                $(this).removeAttr('data-src');
            });
        }
    );
}

function renderTvTableau(date){

    $("#fixtures").css("opacity", "0.2");

    $.get(
        ajaxUrl+"/ajax/getTvTableauByDate.php",
        {
            date : date
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $("#fixtures").html(result.data);
                $("#fixtures").css("opacity", "1");
            }
        }
    );
}

function renderResultsList(){
    var $picker = $("#datepicker_results");
    var date = new Date($picker.datepicker('getDate'));
    date = moment(date).format("YYYY-MM-DD");

    var todayTimeStamp = +new Date; // Unix timestamp in milliseconds
    var oneDayTimeStamp = 1000 * 60 * 60 * 24; // Milliseconds in a day
    var diff = todayTimeStamp - oneDayTimeStamp;
    var yesterdayDate = new Date(diff);
    var yesterdayString = yesterdayDate.getFullYear() + '-' + (yesterdayDate.getMonth() + 1) + '-' + yesterdayDate.getDate();

    Cookies.set('results_date', date, { expires: 0.01, path: '/' });

    $("#fixtures").css("opacity", "0.2");
    $(".fa-calendar-alt").show();
    $(".fa-times").addClass("hidden");

    $.post(
        ajaxUrl+"/ajax/getResultsByDate.php",
        {
            date : date
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $("#fixtures").html(result.list);
                $("#fixtures").css("opacity", "1");
                $("#fixtures_date").html(result.date);
                if(result.next_disabled == 1){
                    $("#results_next").addClass("nav_disabled");
                } else {
                    if(yesterdayString == date && $("#skip_today").length){
                        $("#results_next").addClass("nav_disabled");
                    } else {
                        $("#results_next").removeClass("nav_disabled");
                    }
                }
                $('img[data-src]').each(function(img){
                    $(this).attr('src', $(this).data('src'));
                    $(this).removeAttr('data-src');
                });
            }
        }
    );

    $("#datepicker_results").hide();
}

function checkNotificationCheckboxesOld(){ // Old one

    if($(".notification_switch").length > 0){
        $(".notification_switch").each(function(c,item){
            if(localStorage.getItem($(this).data("match-id"))){
                $(this).prop('checked', true);
                if($("#is_match_page").length > 0){
                    $(".inmatch-notifications-label > .fa-star").addClass("star-activated");
                } else {
                    $(this).prev().addClass("star-activated");
                }

            }
            if($("#is_match_page").length > 0){
                new Switchery(item,{ size: 'large' });
            } else {
                new Switchery(item,{ size: 'small' });
            }
        });
    }

    if($(".xl_fav_team").length > 0){
        $(".xl_fav_team").each(function(c,item){
            if(localStorage.getItem($(this).data("match-id"))) {
                $(this).find(".fa-star").addClass('star-activated');
            }
        });
    }
    $(".fixtures_notification").show();
}

function refresh_my_fixtures(){
    if($("#my-fixtures-page").length > 0){
        var fixtures_count = 0;
        var live_count = 0;
        $.post(
            ajaxUrl+"/ajax/getMyFixtures.php",
            {
                //user_id : localStorage.getItem("fotboll_com_identifier")
                user_id : Cookies.get("fotboll_com_identifier")
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    fixtures_count = result.count;
                    $("#fixtures").html(result.data);
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    $.post(
                        ajaxUrl+"/ajax/getMyLiveFixtures.php",
                        {
                            //user_id : localStorage.getItem("fotboll_com_identifier")
                            user_id : Cookies.get("fotboll_com_identifier")
                        },
                        function(data){
                            var result2 = $.parseJSON(data);
                            if(result2.success == true){
                                live_count = result2.count;
                                if(result2.data != undefined){
                                    //$("#my_live_empty").hide();
                                    $("#fixtures_live_list").html(result2.data);
                                }
                            }
                        }
                    );
                    if(fixtures_count > 0 || live_count > 0) {
                        checkNotificationCheckboxes();
                        //loadOdds();
                    } else {
                        if(fixtures_count == 0 && live_count == 0){
                            Cookies.remove("my_fixtures_count");
                            $(".my-matches-count").html("");
                            $(".my-matches-count").removeClass("my-matches-count-show");
                            $(".my-matches-count").fadeOut();
                        }
                    }
                }
            }
        );
    }
}
function checkNotificationCheckboxes(){ // Old one

    if($(".toggle-notification").length > 0){
        $(".toggle-notification").each(function(c,item){
            if(localStorage.getItem($(this).data("match-id"))){
                $(this).data('activated', 1);
                if($("#is_match_page").length > 0){
                    $(".inmatch-notifications-label > .fa-star").addClass("star-activated");
                } else {
                    $(this).html('<i class="fas fa-check notification-activated" data-fa-transform="shrink-10 up-.5" data-fa-mask="fas fa-bell"></i>');
                }

            }
            if($("#is_match_page").length > 0){
                new Switchery(item,{ size: 'large' });
            } else {
                new Switchery(item,{ size: 'small' });
            }
        });
    }

    /*if($(".xl_fav_team").length > 0){
        $(".xl_fav_team").each(function(c,item){
            if(localStorage.getItem($(this).data("match-id"))) {
                $(this).find(".fa-star").addClass('star-activated');
            }
        });
    }*/
    $(".toggle-notification").show();
}

function updateOddsList(type = "3way"){
    $(".odds-fixture-placeholder").each(function(i){
        var parent = $(this);
        var match_id = $(this).data("match-id");
        $.get(
            ajaxUrl+"/ajax/getOddsPerMatch.php",
            {
                match_id : match_id,
                type : type
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    Object.keys(result.data).forEach(key => {
                        parent.find(`[data-odds='${key}']`).text(result.data[key]);
                    });
                }
            }
        )
    });
}
